import { css } from "@emotion/react";
import { FormLabel, Radio } from "@zapier/design-system";

const intervalContainer = css`
  display: flex;
  gap: 30px;
  width: 100%;
  @media (min-width: 715px) {
    width: auto;
  }
`;

type Props = {
  /* Discount to be displayed for Annual plans in percent */
  annualDiscountPercent: number;
  onChange: (_: boolean) => void;
  isAnnual: boolean;
};

export const IntervalToggle = ({
  annualDiscountPercent,
  isAnnual,
  onChange,
}: Props) => {
  return (
    <div css={intervalContainer}>
      <FormLabel isSelected={!isAnnual}>
        <Radio
          checked={!isAnnual}
          name="interval-radio-monthly"
          onChange={() => onChange(!isAnnual)}
          value="monthly"
        />
        Pay monthly
      </FormLabel>
      <FormLabel isSelected={isAnnual}>
        <Radio
          checked={isAnnual}
          name="interval-radio-yearly"
          onChange={() => onChange(!isAnnual)}
          value="yearly"
        />
        Pay yearly (Save {annualDiscountPercent}%)
      </FormLabel>
    </div>
  );
};
